/**
 * Created by Claude on 04.08.2026
 */

class SpineSlotPositioning extends BaseComponent {
    findSpine() {
        let parent = this.node.getParent();
        while (parent && !(parent instanceof cleverapps.Spine)) {
            parent = parent.getParent();
        }
        return parent;
    }

    // the node must sit directly under the spine - onParented fires on the node being
    // added, not on its descendants, so a deeper node would never see its slot
    onParented() {
        const options = this.options;

        const slotName = PrefabBuilder.resolveProperty(options.slot, this.context);
        const spine = slotName && this.findSpine();
        const slot = spine && spine.hasSlot(slotName) && spine.getSlot(slotName);

        if (!slot) {
            this.node.removeFromParent();
            return;
        }

        if (this.node.parent === slot) {
            return;
        }

        this.node.removeFromParent(false);

        const slotZOrder = PrefabBuilder.resolveProperty(options.slotZOrder, this.context);
        if (slotZOrder !== undefined) {
            slot.setLocalZOrder(slotZOrder);
        }

        slot.addChild(this.node);

        if (slot.width && slot.height && !options.noFit) {
            if (this.node instanceof cleverapps.CountDownView && !this.node.background) {
                // a countdown without a background: the slot is its text box, otherwise the box is the first
                // string's size and every longer string is fitted into it ("2d" -> "1d 23h" at a third).
                // With a background the box is the background, so the whole countdown scales into the slot
                this.node.fitTo(slot.width, slot.height);
            } else if (!(this.node instanceof cc.LabelTTF)) {
                cleverapps.UI.fitToBox(this.node, { width: slot.width, height: slot.height });
            } else if (options.noWrap) {
                this.node.fitTo(slot.width, slot.height);
            } else {
                this.node.setDimensions(slot.width, 0);
                this.node.fitTo(undefined, slot.height);
            }
        }

        if (options.position) {
            this.node.setAlignment(options.position);
        } else {
            this.node.setAlignment(slot.width / 2, slot.height / 2);
        }
    }
}

Prefab.registerComponent("SpineSlotPositioning", SpineSlotPositioning);
